import { useEffect, useState } from 'react';
import {
  getShowcaseItems,
  insertShowcaseItem,
  updateShowcaseItem,
  deleteShowcaseItem,
  getShowcaseComments,
  deleteShowcaseComment,
  createShowcaseComment,
} from '../../../api/adminApi';
import './AppShowcaseManage.css';

const AppShowcaseManage = () => {
  const [items, setItems] = useState<any[]>([]);
  const [title, setTitle] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [content, setContent] = useState('');
  const [editItem, setEditItem] = useState<any | null>(null);
  const [openComments, setOpenComments] = useState<Record<number, boolean>>({});
  const [commentsMap, setCommentsMap] = useState<Record<number, any[]>>({});
  const [commentInputs, setCommentInputs] = useState<Record<number, string>>({});

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    const response = await getShowcaseItems();
    setItems(response.data ?? []);
  };

  const handleCreate = async () => {
    if (!title.trim() || !content.trim()) {
      alert('제목과 내용을 입력하세요.');
      return;
    }
    await insertShowcaseItem({ title: title.trim(), imageUrl: imageUrl.trim(), content: content.trim() });
    setTitle('');
    setImageUrl('');
    setContent('');
    loadItems();
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm('삭제하시겠습니까?')) {
      return;
    }
    await deleteShowcaseItem(id);
    loadItems();
  };

  const startEdit = (item: any) => {
    setEditItem(item);
    setTitle(item.title ?? '');
    setImageUrl(item.imageUrl ?? '');
    setContent(item.content ?? '');
  };

  const cancelEdit = () => {
    setEditItem(null);
    setTitle('');
    setImageUrl('');
    setContent('');
  };

  const handleUpdate = async () => {
    if (!editItem?.id) {
      return;
    }
    if (!title.trim() || !content.trim()) {
      alert('제목과 내용을 입력하세요.');
      return;
    }
    await updateShowcaseItem(editItem.id, {
      title: title.trim(),
      imageUrl: imageUrl.trim(),
      content: content.trim(),
    });
    cancelEdit();
    loadItems();
  };

  const toggleComments = async (showcaseId: number) => {
    const willOpen = !openComments[showcaseId];
    setOpenComments((prev) => ({ ...prev, [showcaseId]: willOpen }));
    if (willOpen && !commentsMap[showcaseId]) {
      const response = await getShowcaseComments(showcaseId);
      setCommentsMap((prev) => ({ ...prev, [showcaseId]: response.data ?? [] }));
    }
  };

  const handleAddComment = async (showcaseId: number) => {
    const text = (commentInputs[showcaseId] ?? '').trim();
    if (!text) {
      alert('댓글 내용을 입력하세요.');
      return;
    }
    await createShowcaseComment(showcaseId, text);
    setCommentInputs((prev) => ({ ...prev, [showcaseId]: '' }));
    const response = await getShowcaseComments(showcaseId);
    setCommentsMap((prev) => ({ ...prev, [showcaseId]: response.data ?? [] }));
  };

  const handleDeleteComment = async (showcaseId: number, commentId: number) => {
    if (!window.confirm('댓글을 삭제하시겠습니까?')) {
      return;
    }
    await deleteShowcaseComment(showcaseId, commentId);
    const response = await getShowcaseComments(showcaseId);
    setCommentsMap((prev) => ({ ...prev, [showcaseId]: response.data ?? [] }));
  };

  return (
    <div className="manage-section">
      <h2>자랑게시판(Showcase) 관리</h2>

      <div className="showcase-form">
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="제목" />
        <input value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} placeholder="이미지 URL" />
        <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="내용" />
        <div className="form-buttons">
          {editItem ? (
            <>
              <button className="primary" onClick={handleUpdate}>수정</button>
              <button onClick={cancelEdit}>취소</button>
            </>
          ) : (
            <button className="primary" onClick={handleCreate}>등록</button>
          )}
        </div>
      </div>

      <div className="showcase-list">
        {items.map((item) => (
          <div key={item.id} className="showcase-item">
            <div className="showcase-item-main">
              <strong>{item.title}</strong>
              <span>{item.content}</span>
              {item.imageUrl && <img src={item.imageUrl} alt={item.title} className="showcase-thumb" />}
            </div>
            <div className="showcase-item-actions">
              <button onClick={() => startEdit(item)}>수정</button>
              <button className="danger" onClick={() => handleDelete(item.id ?? 0)}>삭제</button>
            </div>
            <div className="showcase-comments">
              <button onClick={() => toggleComments(item.id ?? 0)}>
                댓글 {commentsMap[item.id ?? 0]?.length ?? 0}
              </button>
              {openComments[item.id ?? 0] && (
                <div className="comment-box">
                  <div className="comment-input">
                    <input
                      value={commentInputs[item.id ?? 0] ?? ''}
                      onChange={(e) =>
                        setCommentInputs((prev) => ({
                          ...prev,
                          [item.id ?? 0]: e.target.value,
                        }))
                      }
                      placeholder="댓글 내용"
                    />
                    <button onClick={() => handleAddComment(item.id ?? 0)}>등록</button>
                  </div>
                  <ul>
                    {(commentsMap[item.id ?? 0] ?? []).map((comment) => (
                      <li key={comment.id}>
                        <span>{comment.nickname ?? '익명'}</span>
                        <p>{comment.content}</p>
                        <button
                          className="danger"
                          onClick={() => handleDeleteComment(item.id ?? 0, comment.id)}
                        >
                          삭제
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppShowcaseManage;
